<template>
  <div class="layout-container">
    <div class="layout-name-row d-flex align-items-center">
      <div class="layout-name-text mx-auto text-truncate" :title="view.name">
        {{ view.name }}
      </div>
      <div>
        <feather-icon
          :id="`actions-view-${view.id}`"
          icon="MoreVerticalIcon"
          size="16"
          class="cursor-pointer tourActions"
          color="#3182ce"
        />
        <b-popover
          :target="`actions-view-${view.id}`"
          triggers="focus"
          placement="bottom"
          custom-class="popover-p-0"
          variant="white"
        >
          <b-list-group class="m-0">
            <b-list-group-item
              class="border-0"
              button
              @click="$emit('edit-view', view)"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50 text-capitalize">
                {{ $t("actions.edit") }}
              </span>
            </b-list-group-item>

            <b-list-group-item
              v-if="view.validations"
              class="border-0"
              button
              @click="$emit('view-history', view)"
            >
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50 text-capitalize">
                Ver historial
              </span>
            </b-list-group-item>

            <b-list-group-item
              class="border-0"
              button
              @click="$emit('remove-view', view.id)"
            >
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50 text-capitalize">
                {{ $t("actions.delete") }}
              </span>
            </b-list-group-item>
          </b-list-group>
        </b-popover>
      </div>
    </div>
    <div class="grid-layout__container" :style="{ height: previewHeight }">
      <div @click="$emit('set-view', view)">
        <widget
          v-for="widget in items"
          :widget="widget"
          :key="widget.local_id"
          :style="{ ...gridItemStyles(widget) }"
          :tab-data="tabData"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Widget from "./LayoutViewsSlot.vue";
import useLayout from "@/composables/layouts";
import { onMounted, reactive, toRefs, computed } from "@vue/composition-api";
import defaultLayout from "@/config/defaultLayout";
import store from "@/store";

export default {
  components: {
    Widget,
  },
  props: {
    view: Object,
  },
  setup(props, { emit }) {
    const showOptions = computed(() => {
      const { slots } = props.view.data;

      return slots.filter(slot => !Array.isArray(slot.data)).every(slot => (slot.type === 'cam'));
    });

    const userLayouts = computed(() => {
      return store.state.layouts.userLayouts.map((l) => ({
        id: l.id,
        name: l.name,
        grid: l.data,
      }));
    });
    let layout = null;

    if (props.view.layout_id === "default") {
      layout = defaultLayout;
    } else {
      layout = userLayouts.value.find((layout) => layout.id === props.view.layout_id);
      if (layout) {
        layout = Object.assign({}, { ...layout });
      } else {
        layout = defaultLayout;
      }
    }

    const tabData = props.view.data;
    const { gridItemStyles, slotHeight } = useLayout(layout, 15);
    const state = reactive({
      items: [],
    });

    // Preview cells are absolutely positioned, so size the container to the real
    // grid height to keep it from overflowing onto the next view's name.
    const previewHeight = computed(() => {
      if (!state.items.length) return `${8 * slotHeight.value}px`;
      const rows = Math.max(
        ...state.items.map((w) => (Number(w.y) || 0) + (Number(w.h) || 0))
      );
      return `${(rows || 8) * slotHeight.value}px`;
    });

    onMounted(() => {
      if (props.view && props.view.data.gridItems) {
        state.items = props.view.data.gridItems;
      } else if (layout && layout.grid) {
        state.items = [...layout.grid];
      } else {
        state.items = [];
      }
    });

    return {
      ...toRefs(state),
      gridItemStyles,
      tabData,
      showOptions,
      previewHeight,
    };
  },
};
</script>

<style lang="scss" scoped>
.layout-container {
  position: relative;
  .btn-remove {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 3;
    display: none;
  }
  &.selected,
  &:hover {
    .btn-remove {
      display: block;
    }
    .app-grid {
      .slot-item {
        border: 1px solid #fff;
      }
    }
  }
}

.layout-name-text {
  // allow the flex item to shrink so text-truncate can apply
  min-width: 0;
}
</style>
